export enum CampaignState {
  PAST = 'PAST',
  ONGOING = 'ONGOING',
  UPCOMING = 'UPCOMING',
}
